// extracted by mini-css-extract-plugin
export var divider = "_yd-0";